let deliveryClickCollect = false;
let isMobile;
let lastClickedPos = 0;
$(document).ready(function() {
    isMobile = detectmob();
    $('input:not([data-bind])').focus(function() {
        $(this).data('placeholder', $(this).attr('placeholder'));
        $(this).attr('placeholder', '');
    });
    $('input:not([data-bind])').blur(function() {
        $(this).attr('placeholder', $(this).data('placeholder'));
    });
    if ($(window).width() > 767) {
        // Height for homepage comming soon carousal
        let maxHeightnt = 0;
        $('.author-product-coming-soon a').each(function() {
            const $thehPath = $(this).find('.pl-tile-author--coming-soon .pl-tile__description-container');
            maxHeightnt = Math.max(maxHeightnt, $thehPath.height());
        });
        $('.pl-tile-author--coming-soon .pl-tile__description-container').height(maxHeightnt);
    }

    $(document).on('click', '.apply,.removeAddressAction button,.changeaddbutton,.closeLightBox', function() {
        $('.overlay').click();
        $('html').removeClass('noScroll');
    });
    $(document).on('click', '.modal_close', function() {
        const $overlay = $('.overlay');
        // Bug fix = 'ignore-close' to prevent conflicts with other overlays
        // e.g. Tariff Finder 'Filter' button for mobile
        if (!$overlay.data('ignore-close')) {
            $overlay.click();
        }
        $('html').removeClass('noScroll');
        $('body').removeClass('ovrflwHid');
        $('body').removeClass('overflowXhide');
        $('body').removeClass('sidemenu-open');
        $('.callMenus').removeClass('active');
        if ($('.callMenus').is(':visible')) {
            overlayClick(true);
        }
        if ($('.sidemenu').is(':visible')) {
            overlayClick(true);
        }
    });

    $(document).on('click', '.generic-modal', function(e) {
        e.preventDefault();
        CPW.Plugins.Modal.genericModalEvent(e.currentTarget);
    });

    $(document).on('click', '.confirmChanges', function() {
        $('html').removeClass('noScroll');
    });
    // Confirm address position
    $('.confirmAddrss').click(function() {
        $(document).scrollTop($('#otherAddress_0').offset().top);
    });
    // when escape is pressed
    $(document).on('keyup', function(evt) {
        if (evt.keyCode == 27) {
            $('html').removeClass('noScroll');
        }
    });

    // Tipbox Close Script
    $(document).on('click touchstart', '.closeMe, body', function(e) {
        if (!$(e.target).hasClass('compareTipBox')) {
            $('.tipbox').hide();
        }
    });

    // Touch alternative for hover effect
    $(document).on('touchstart', '.check-buttons .compareTipBox', function(e) {
        if ($(e.target).hasClass('btn')) {
            $(e.target).css('background-color', '#e6e6e6');
        } else {
            $(e.target.parentElement).css('background-color', '#e6e6e6');
        }
    });
    $(document).on('touchend', '.check-buttons .compareTipBox', function(e) {
        if ($(e.target).hasClass('btn')) {
            $(e.target).css('background-color', '#ffffff');
        } else {
            $(e.target.parentElement).css('background-color', '#ffffff');
        }
    });

    // added to match the height of the overlay sliding from right
    $('.modal.slideInMble').on('shown.bs.modal', function() {
        if (isMobile == true) {
            $('html,body').addClass('noScrollModalMobile');
        }
        const currMoalWindow = $(this);
        matchModalHt(currMoalWindow);
    });
    $('.modal').on('hide.bs.modal', function() {
        $('html,body').removeClass('noScrollModalMobile');
        $('.header > .hBtm.fixed').css('overflow-y', 'hidden');
    });
    $('.modal').on('show.bs.modal', function() {
        lastClickedPos = $(window).scrollTop();
        $('.header > .hBtm.fixed').css('overflow-y', 'scroll');
    });
    $('.modal').on('hidden.bs.modal', function() {
        lastClickedPos = 0;
    });

    // orientationchange captured
    window.addEventListener('orientationchange', function() {
        if (window.orientation == 90 || window.orientation == -90) {
            if ($(window).scrollTop() == 0) {
                $('html,body').animate({
                    scrollTop: 0
                }, 'slow');
            }
            if ($('.callMenus').is(':visible')) {
                overlayClick(true);
            }
            if ($('.sidemenu').is(':visible')) {
                overlayClick(true);
            }
        }
        if (window.orientation == 0 || window.orientation == 180) {
            if ($(window).scrollTop() == 0) {
                $('html,body').animate({
                    scrollTop: 0
                }, 'slow');
            }
            if ($('.callMenus').is(':visible')) {
                overlayClick(true);
            }
            $('.header').removeClass('open');
            $('.dropOverlay').addClass('hide');
        }
        if ($('#modalWindows .modal.fade').length > 0 && isMobile) {
            $('html').addClass('noScroll');
        }
    }, false);

    // script for search focus
    const Input = $('input[name="main_search"]');
    const default_value = Input.val();
    Input.focus(function() {
        if (Input.val() == default_value) {
            Input.val('');
        }
    }).blur(function() {
        if (Input.val().length == 0) {
            Input.val(default_value);
        }
    });

    // script for Trade In focus
    const TInput = $('input[name="TradeIn_search"]');
    const defaultT_value = TInput.val();
    TInput.focus(function() {
        if (TInput.val() == defaultT_value) {
            TInput.val('');
        }
    }).blur(function() {
        if (TInput.val().length == 0) {
            TInput.val(defaultT_value);
        }
    });

    // Show more Stores - Store Locator
    $('button.arw').click(function() {
        $('.sLSearchResult').scrollTop(150);
    });

    // Read_More_less
    read_more_less();
    $('.morelink').click(function() {
        const readMoreLabel = 'Read More';
        const readLessLabel = 'Read less';
        const thisObj = $(this);
        if (thisObj.hasClass('less')) {
            thisObj.removeClass('less').html(readMoreLabel);
        } else {
            thisObj.addClass('less').html(readLessLabel);
        }
        $(this).parent().prev().toggle();
        $(this).prev().toggle();
        return false;
    });

    // Show more Filters
    let status = 'less';
    $(document.body).on('click', '.moreFilter', function() {
        if (status == 'less') {
            $(this).html('<span class="Ctm_icons HideFBST"></span>Show Less');
            $(this).parents('[rel="showMoreData"]').find('[rel="showMore"]').show();
            status = 'more';
        } else if (status == 'more') {
            $(this).html('<span class="Ctm_icons ShowFBST"></span>Show More');
            $(this).parents('[rel="showMoreData"]').find('[rel="showMore"]').hide();
            status = 'less';
        }
    });

    // For PDP
    if ($('.upfront').length > 0) {
        arrangeBanner();
    }

    arrangeSliderTicks('monthly');
    arrangeSliderTicks('upfront');
    arrangeSliderTicks('price');
    arrangeSliderTicks('screen');

    function arrangeSliderTicks(parent) {
        let noOfSteps = $('.' + parent).find('div.steps > span.tick').length;
        noOfSteps = noOfSteps - 1;
        const marginOffset = 100 / noOfSteps;
        $('.' + parent).find('div.steps > span.tick').each(function(i) {
            $(this).css('left', i * marginOffset + '%');
        });
    }

    function arrangeBanner() {
        const bannerPos = $('.upfront').parent().position().left - 100;
        $('.bannerImage').css('left', bannerPos);
    }

    $(window).resize(function() {
        arrangeSliderTicks('monthly');
        arrangeSliderTicks('upfront');
        arrangeSliderTicks('price');
        arrangeSliderTicks('screen');

    });

    function tog(v) {
        return v ? 'addClass' : 'removeClass';
    }

    $(document).on('input keyup touchend', '.clearable', function() {
        $(this).parent().find('.srchDlt')[tog($.trim(this.value).length > 0)]('x');
        if ($.trim(this.value).length <= 0 && $(this).parent().find('input.clearable').hasClass('postCodeInputValue')) {
            $('span[iconfor="storeChecker"]').hide();
        }
    });

    $(document).on('touchstart click', '.srchDlt.x', function() {
        $(this).removeClass('x');
        // ST2-2369 change to focus
        $(this).parent().find('input.clearable').val('').focus();
        if ($(this).parent().find('input.clearable').hasClass('postCodeInputValue')) {
            $('span[iconfor="storeChecker"]').hide();
        }
        dltSearchClicked = false;
    });

    // New plan & upgrade plan
    $('.optionsNav li').click(function() {
        const currentIndex = $('.optionsNav li').index(this);
        if (currentIndex == 0) {
            $('.upgradeData > div.dTop').addClass('hide');
        } else if (currentIndex == 1) {
            $('.upgradeData > div.dTop').removeClass('hide');
        }

        /* for New-Upgrade tab msg bus */
        let pageNameDataParam = 'Choose Tariff';
        let tabSelected = '';
        tabSelected = localStorage.getItem('ngStorage-propTypeP');
        if (tabSelected != null) {
            tabSelected = tabSelected.replace(/'/g, '');
        }
        if (tabSelected == 'ud' || tabSelected == 'pgud') {
            tabSelected = 'Upgrade';
        } else {
            tabSelected = 'New';
        }
        if (pathName != null && pathName.indexOf('tariff') < 0) {
            pageNameDataParam = pathName + ':' + tabSelected;
        } else {
            pageNameDataParam = pageNameDataParam + ':' + dealTypeValue + ':' + tabSelected;
            const brand = localStorage.getItem('pageNameBrand');
            if (brand != null && brand != '') {
                pageNameDataParam = pageNameDataParam + ':' + brand;
            }
            const model = localStorage.getItem('deviceName');
            if (model != null && model != '') {
                pageNameDataParam = pageNameDataParam + ':' + model;
            }
        }
        const obj = new Object();
        obj.pageName = pageNameDataParam;
        $('.optionsNav').data('event-params', obj);
        const elementName = $('.optionsNav').attr('data-event-name');
        const channelName = $('.optionsNav').attr('data-element-channel');
        const dataObj = new Object();
        dataObj.dataEventName = $('.optionsNav').attr('data-event-name');
        dataObj.dataEvent = $('.optionsNav').attr('data-event');
        dataObj.dataEventParams = $('.optionsNav').data('event-params');
        addEventsToMessageBus(channelName, elementName, dataObj);
    });

    // Add & Remove Other Filters
    $(document.body).on('click', '.addOtherFilters', function() {
        $('.otherFilters').slideDown(function() {
            $('.addOtherFilters').hide();
            $('.removeOtherFilters').removeClass('hide');
        });
    });

    $(document.body).on('click', '.removeOtherFilters', function() {
        $('.otherFilters').slideUp(function() {
            $('.removeOtherFilters').addClass('hide');
            $('.addOtherFilters').show();
        });
    });

    // Selecting filters
    $(document.body).on('click', '.fCategories > ul > li:not(.disable)', function(e) {
        if ($(this).hasClass('any')) {
            if (!($(this).hasClass('active'))) {
                $(this).parents('.fCategories').find('ul > li:not(:first)').removeClass('active');
                if ($(this).parents('.fCategories').find('ul > li:not(:first)').find(':checkbox').length > 0) {
                    $(this).parents('.fCategories').find('ul > li:not(:first)').find(':checkbox').attr('checked', false);
                }
            }
        } else {
            $(this).parents('.fCategories').find('ul > li.any').removeClass('active');
            if ($(this).parents('.fCategories').find('ul > li:not(:first)').find(':checkbox').length > 0) {
                $(this).parents('.fCategories').find('ul > li.any').find(':checkbox').attr('checked', false);
            }

        }
        if ($(this).parents('.fCategories').find('ul > li:not(:first)').find(':checkbox').length > 0) {
            const $checkbox = $(this).find(':checkbox');
            $checkbox[0].checked = !$checkbox[0].checked;
            $checkbox.trigger('change');
            e.stopImmediatePropagation();
        }
        $(this).toggleClass('active');
        return false;
    });

    // Reseting filters
    $(document.body).on('click', '.reset', function() {
        $('.fCategories li').removeClass('active');
        $('.cust-check input.checkbox').attr('checked', false);
        return false;
    });

    // Accessories finder condition to select sub filters
    $(document.body).on('click', '.category > ul > li', function() {
        const categoriesSelected = $('.category > ul > li.active').children().length;
        if (categoriesSelected > 1) {
            $('.fCategories.type').addClass('hide');
        } else {
            $('.fCategories.type').removeClass('hide');
        }
    });

    // Sticky Header
    $(window).scroll(function() {
        if (document.body.classList.contains('body-scroll-locked')) return;
        let menuStartPos = 0;
        if ($('.header .hBtm').length > 0 && !$('html').hasClass('noScroll')) {
            menuStartPos = $('.hTop').height();
            const headerHeight = $('.hBtm').outerHeight();
            const headerBottomHeight = $('.hBtm').height();

            if ($(window).scrollTop() > menuStartPos) {
                $('.header .hBtm').addClass('fixed');
                $('.mega-navigation__container').addClass('fixed');
                $('.appNavPopup, .appNavPopupCompare').css({
                    'top': headerBottomHeight + 10
                });
                if (!$('.hBtm').hasClass('prevent-fixed')) {
                    $('.header').css('margin-bottom', headerHeight + 'px');
                }
                $('.header .hBtm').parent('.header').next('div:visible').addClass('addFixedMargin');
            } else {
                $('.header .hBtm').parent('.header').next('div:visible').removeClass('addFixedMargin');
                $('.header .hBtm').removeClass('fixed');
                $('.header .hTop').css('top', 0);
                $('.mega-navigation__container').removeClass('fixed');
                $('.appNavPopup, .appNavPopupCompare').css({
                    'top': headerHeight + 10
                });
                $('.header').css('margin-bottom', '0px');
            }
        }
        if ($(window).scrollTop() > menuStartPos) {
            $('.backToTop').show();
        } else if ($(window).scrollTop() <= menuStartPos) {
            $('.backToTop').hide();
        }
    });

    // Back to Top
    $('.backToTop').click(function() {
        $('html,body').animate({
            scrollTop: 0
        }, 'slow');
    });

    $('.callMenus').click(function() {
        ews.components.header.search.close();
        ews.components.header.overlay.mobile.toggle();
    });

    $('.overlay').click(function() {
        $('.menuContent').scrollTop(0);
        overlayClick(false);
    });

    function overlayClick(preventAnimation) {
        let desktopMenuIsOpen = false;
        let mobileMenuIsOpen = desktopMenuIsOpen;
        let menuIsOpen = false;
        // required for non topnav pages e.g. Checkout
        const hasMeganav = (typeof ews.components.header === 'object');
        if (preventAnimation) {
           let animationTime = 0;
        }

        if (hasMeganav) {
            desktopMenuIsOpen = ews.components.header.meganav.isOpen();
            mobileMenuIsOpen = ews.components.header.overlay.mobile.isOpen();
            menuIsOpen = desktopMenuIsOpen || mobileMenuIsOpen;
        }

        if (mobileMenuIsOpen) {
            ews.components.header.overlay.mobile.close();
        }

        const overlay = $('.overlay');
        const body = $(document.body);
        const htmlDoc = $(document.documentElement);
        const menuContent = $('.menuContent');
        const callMenus = $('.callMenus');

        body.removeClass('ovrflwHid');
        htmlDoc.removeClass('noScroll');
        callMenus.removeClass('active');
        body.removeClass('overflowXhide');
        menuContent.scrollTop(0);
        body.removeClass('sidemenu-open');

        $('.sidemenu.right').removeClass('open');

        if (!menuIsOpen) {
            $('html,body').animate({
                scrollTop: lastClickedPos
            }, 'slow', function() {
                lastClickedPos = 0;
            });
        }

        overlay.addClass('hide');

        if ($('.header').hasClass('scrolledMenu')) {
            $('.addFixedMargin').show();
        }
    }

    $(document.body).on('click', '.mobileMenu .reset-view', function() {
        $('.mobileMenu').find('.active').each(function() {
            closeMenuItems($(this), $(this).find('ul'));
        });
    });

    // Multilevel Accordian
    $(document.body).on('click', '.menuWrap > li', function(event) {
        event.preventDefault();
        event.stopPropagation();

        const selectedItem = $(this);
        const firstLMenu = selectedItem.find('ul.firstLMenu');
        const secondLMenu = selectedItem.find('ul.secondLMenu');
        const href = selectedItem.find('a').attr('href');
        const url = (href == '#') ? '' : href;
        const hasChildItems = (!!selectedItem.find('ul').length);

        // redirect if clicked has a url. Also must either be a standalone link or the only active link
        if (!!url && (!hasChildItems || ews.components.header.overlay.mobile.isActive(selectedItem))) {
            // direct links (non accordions or active)
            CPW.Plugins.Browser.redirect(url);
            return true;
        } else if (selectedItem.parent('ul').hasClass('primaryMenu')) {

            if (firstLMenu.length > 0) {
                let category = '';
                category = selectedItem.children('a').text().trim();
                const primaryNavigator = {};
                primaryNavigator['data-analytics-navbuttonname'] = category;
                $('.firstLMenu').data('event-params', primaryNavigator);
                const elementName = firstLMenu.attr('data-event-name');
                const channelName = firstLMenu.attr('data-element-channel');
                const dataObj = new Object();
                dataObj.dataEventName = firstLMenu.attr('data-event-name');
                dataObj.dataEvent = firstLMenu.attr('data-event');
                dataObj.dataEventParams = firstLMenu.data('event-params');
                addEventsToMessageBus(channelName, elementName, dataObj);

                /* Message bus complete: on click of primary navigation (Mobile view) */
                CPW.Plugins.lazyLoad(firstLMenu.find('img[data-src]'));
                openMenuItems(selectedItem, firstLMenu);
            }
            return false;
        } else if (selectedItem.parent('ul').hasClass('firstLMenu')) {
            if (secondLMenu.length > 0) {
                if (!(secondLMenu.is(':visible'))) {

                    /* Message bus starts: on click of secondary navigation (Mobile view) */
                    let category = '';
                    category = selectedItem.children('a').text().trim();
                    const secondaryNavigator = {};
                    secondaryNavigator['data-analytics-secondary-nav'] = category;
                    secondLMenu.data('event-params', secondaryNavigator);
                    elementName = secondLMenu.attr('data-event-name');
                    channelName = secondLMenu.attr('data-element-channel');
                    dataObj = new Object();
                    dataObj.dataEventName = secondLMenu.attr('data-event-name');
                    dataObj.dataEvent = secondLMenu.attr('data-event');
                    dataObj.dataEventParams = secondLMenu.data('event-params');
                    addEventsToMessageBus(channelName, elementName, dataObj);

                    /* Message Bus complete: on click of secondary navigation (Mobile view) */
                    openMenuItems(selectedItem, secondLMenu);
                } else {
                    closeMenuItems(selectedItem, secondLMenu);
                }
            }
            return false;
        }
    });

    function closeMenuItems(outerMenu) {
        ews.components.header.overlay.mobile.clearLevel();
        outerMenu.closest('ul').removeClass('selected');
        outerMenu.removeClass('active');
    }

    function openMenuItems(selectedItem) {
        ews.components.header.overlay.mobile.setLevel(selectedItem.parents('ul').length);
        const $active = selectedItem.find('.active');

        // clear any child level classes
        selectedItem.find('.selected').removeClass('selected');
        $active.removeClass('active');
        $active.find('ul').css('display', '');

        // set new classes
        selectedItem.closest('ul').addClass('selected');
        selectedItem.addClass('active');
    }

    // Custom Dropdown Fetching value
    $(document.body).on('click', '.cust-dropdown .dropdown-menu li', function() {
        $(this).closest('.dropdown').find('button').val($(this).text());
        $(this).closest('.dropdown').find('button').html('<span class="icon popFilter pull-left marginR5 marginT5"></span>' + $(this).text());
        $(this).closest('.dropdown').find('[data-toggle=dropdown]').dropdown('toggle');
        return false;
    });

    // Footer Links
    $('.footer ul.subCat > li.mainCat').click(function() {
        if (!($(this).next('.otherLinks').is(':visible'))) {
            $(this).addClass('active');
            $(this).next('.otherLinks').slideDown();
        } else {
            $(this).removeClass('active');
            $(this).next('.otherLinks').slideUp();
        }
    });

    // Model Enable
    $(document.body).on('click', '#manufacture .dropdown-menu li', function() {
        $('#model').removeClass('disabled');
        $('#model').find('button').attr('disabled', false);
        return false;
    });

    $(document.body).on('click touchstart', '.closeTooltip', function() {
        $(this).closest('.popover').hide();
    });
    $(document.body).on('click touchstart', '.closeDropDwn', function() {
        $(this).parents('ul.dropdown-menu').slideUp('slow', function() {
            $(this).parents('li.dropdown').removeClass('open');
            $(this).removeAttr('style');
            $('.header').removeClass('open');
            $('.dropOverlay').addClass('hide');
            $(document.body).removeClass('ovrflwHid');
            $(document.documentElement).removeClass('noScroll');
        });
    });

    // Additional phone finder
    let ratingClass;
    $('.product').each(function() {
        const uniqueID = $(this).attr('id');
        if (uniqueID != null && uniqueID != 'undefined') {
            const star = parseFloat(uniqueID.split('-')[0]);
            let beforeDecimal = Math.floor(star);
            const afterDecimal = star - Math.floor(star);

            if (afterDecimal < 0.75) {
                const h = (afterDecimal * 10);
                if (h > 2.5) {
                    beforeDecimal = (beforeDecimal + 5 * 0.1) * 10;
                } else {
                    beforeDecimal = beforeDecimal * 10;
                }
            } else {
                beforeDecimal = (beforeDecimal + 1) * 10;
            }
            ratingClass = 'rating-' + beforeDecimal;
            $(this).find('span.rating-static').addClass(ratingClass);
        }
    });
    $('.cust-select').each(function() {
        const dropselected = $(this).find(':selected').text().trim();
        if (dropselected != null) {
            $(this).find('[data-bind="label"]').attr('value', dropselected);
        }

    });

    if ($('.otherFilters .fCategories').find('input[type="checkbox"]:checked').length > 0) {
        $('.addOtherFilters').click();
    }

    $(document).on('click', '#checkLocation', function() {
        let addLength = $.trim($('.enterAPOP .input-group .form-control').val()).length;
        if (!(addLength > 0)) {
            $('.sLFilterResultHldr').append('<div class="sLSRError"><span class="Ctm_icons ErrorSLM"></span><p class="errorIcon">Permission from browser needed before finding your location. Please enter a place or poscode.</p></div>');  
        } else {
            $('.sLFilterResultHldr').remove('div.sLSRError');
        }
    });

    $('#SearchMobile').click(function(e) {
        e.preventDefault();
        ews.components.header.overlay.mobile.close();
        $(this).parent().toggleClass('active');
        ews.components.header.search.toggle();
    });

    $('.siteSearchResult').keyup(function(e) {
        if (e.keyCode == 13) {
            invokeSearchResult();
        }
    });

    $(document).on('click', '.autocompleteSuggestionsDropdown li', function() {
        invokeSearchResult();
    });

    $(document).on('click', '#searchButtonDesktop', function() {
        searchTypevalue();
        invokeSearchResult();
    });

    // hiding the search result box for Desktop
    $('body').on('click', function(e) {
        $('#searchButtonDesktop').each(function() {
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.searchResultDesktop').has(e.target).length === 0) {
                $('.searchResultDesktop').hide();
            }
        });
    });

    // hiding the search result box for mobile
    $('body').on('touchstart click', function(e) {
        $('#SearchMobile').each(function() {
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.menuSearch').has(e.target).length === 0) {
                ews.components.header.search.close();
            }
        });
    });

    // Checkbox all
    $(document).on('click', 'label[for="all"]', function() {
        const $checkbox = $(this).parent('.cust-check').find(':checkbox');
        if (!($checkbox[0].checked)) {
            $(this).parents('.custCheckWrap').find('.checkbox:not(#all)').each(function() {
                this.checked = false;
            });
        }
    });

    $(document).on('click', '.cust-check label:not(#checkAll)', function() {
        if ($(this).parents('.custCheckWrap').find('.checkbox:not(#all)').length > 0) {
            const $checkbox = $(this).parents('.custCheckWrap').find('.checkbox#all');
            if ($checkbox[0].checked) {
                $checkbox[0].checked = false;
            }
        }
    });

    // Hide Popover Onclick of body
    $('body').on('click', function(e) {
        $('[data-toggle="popover"]').each(function() {
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                $(this).popover('hide');
            }
        });
    });

    $(document).on('click', '[rel="collapse"]', function() {
        const obj = $(this);
        let parent = false;
        const style = obj.parents('.panelGroup').attr('rel');

        if (obj.hasClass('panels')) {
            parent = true;
        }
        accordian(obj, parent, style);
    });

    // Accordian Function
    function accordian(currObj, parentClass, style) {
        if (currObj.hasClass('deviceCategoryAccHeading')) {
            return;
        }
        if (parentClass == false) {
            if (!(currObj.parents('.panels').find('.panelBody').is(':visible'))) {
                if (style == 'single') {
                    const visiblePanel = $('.panelBody:visible');
                    if (visiblePanel.length > 0) {
                        const firstOpenPanel = visiblePanel.parents('.panels').find('.deviceCategoryAccHeading').first().offset().top;

                        if (firstOpenPanel < currObj.offset().top) {
                            let theTop;
                            if ($('.pageName').val() == 'pdpPage') {
                                theTop = firstOpenPanel - $('.deviceinfoSummary').outerHeight();
                            } else {
                                theTop = firstOpenPanel;
                            }
                            $('html, body').animate({
                                scrollTop: theTop
                            }, 'fast');
                        }

                        visiblePanel.slideUp('slow', function() {
                            $('.panels:visible').removeClass('active');
                            getProperTop(currObj);
                        });
                    } else {
                        getProperTop(currObj);
                    }
                }
            } else {
                currObj.parent('.panels').removeClass('active');
                currObj.parents('.panels').find('.panelBody').slideUp();
            }
        } else if (!(currObj.find('.panelBody').is(':visible'))) {
            if (style == 'single') {
                $('.panelBody:visible').slideUp();
                $('.panels:visible').removeClass('active');
            }
            currObj.addClass('active');
            currObj.find('.panelBody').slideDown();
        } else {
            currObj.removeClass('active');
            currObj.find('.panelBody').slideUp();
        }
    }

    $(document).on('click', '.tradeSearchDrop li', function() {
        const serVal = $(this).html();
        $('.tradeInFldRsltHldr input').val(serVal);
    });

    // apply dynamic scroll to select
    $('.cust-select').each(function() {
        const obj = $(this);
        if (obj.data('scroll') != 'no') {
            addDynmcScroll(obj);
        }
    });

    // overlay scroll issue
    $(window).on('mousemove mouseup', function() {
        let $modal, $backdrop, el_height;
        if ($('#fullPlanDetails').is(':visible')) {
            $modal = $('#fullPlanDetails .modal-dialog');
            $backdrop = $('#fullPlanDetails .modal-backdrop');
            el_height = $modal.innerHeight();
        } else {
            $modal = $('#LTCDetails .modal-dialog');
            $backdrop = $('#LTCDetails .modal-backdrop');
            el_height = $modal.innerHeight();
        }

        $backdrop.css({
            height: el_height + 500,
            minHeight: '100%',
            margin: 'auto'
        });
    });

    $('.mobileBBPlans').on('click', '.mobileBBPlansOverlayClick', function() {
        lastClickedPos = $(window).scrollTop();
        $('html,body').animate({
            scrollTop: 0
        }, 'slow');
    });
    // CPW-5289 accordian start
    $(document).on('click', '.modalBodyTitleAccr', function () {
        const target = $($(this).data('target'));
        $(this).toggleClass('accordion-open');
        target.toggleClass('open');
    });
    // CPW-5289 accordian end
});

$(window).load(function() {
    maxHeightVmediaDscptn();
    maxHeightVmediaTitle();
    // Fix heights on window resize
    $(window).resize(function() {
        // Needs to be a timeout function so it doesn't fire every ms of resize
        setTimeout(function() {
            maxHeightVmediaDscptn();
            maxHeightVmediaTitle();
        }, 120);
    });
});

function maxHeightVmediaDscptn() {
    const heights = new Array();

    // Loop to get all element heights
    $('.content-media--vertical .content-media__description').each(function() {
        // Need to let sizes be whatever they want so no overflow on resize
        $(this).css('min-height', '0');
        $(this).css('max-height', 'none');
        $(this).css('height', 'auto');

        // Then add size (no units) to array
        if ($(this).is(':visible')) {
            heights.push($(this).height());
        } else {
            heights.push(getActualHt($(this)));
        }
    });

    // Find max height of all elements
    const max = Math.max.apply(Math, heights);

    // Set all heights to max height
    $('.content-media--vertical .content-media__description').each(function() {
        $(this).css('height', max + 'px');
        // Note: IF box-sizing is border-box, would need to manually add border and padding to height (or tallest element will overflow by amount of vertical border + vertical padding)
    });
}

function maxHeightVmediaTitle() {
    const heights = new Array();

    // Loop to get all element heights
    $('.content-media--vertical .content-media__title').each(function() {
        // Need to let sizes be whatever they want so no overflow on resize
        $(this).css('min-height', '0');
        $(this).css('max-height', 'none');
        $(this).css('height', 'auto');

        // Then add size (no units) to array
        if ($(this).is(':visible')) {
            heights.push($(this).height());
        } else {
            heights.push(getActualHt($(this)));
        }
    });

    // Find max height of all elements
    const max = Math.max.apply(Math, heights);

    // Set all heights to max height
    $('.content-media--vertical .content-media__title').each(function() {
        $(this).css('height', max + 'px');
        // Note: IF box-sizing is border-box, would need to manually add border and padding to height (or tallest element will overflow by amount of vertical border + vertical padding)
    });
}

function addDynmcScroll(elm) {
    let ht = 0;
    elm.find('.dropdown-menu > li').each(function() {
        if (!$(this).hasClass('hide')) {
            ht += getActualHt($(this));
        }
    });
    if (ht > 140 && !elm.find('.dropdown-menu').hasClass('no-scroll')) {
        elm.addClass('addScroll');
    } else {
        elm.removeClass('addScroll');
    }
}

function getActualHt(data) {
    const clone = data.clone();
    clone.css('visibility', 'hidden');
    $('body').append(clone);
    // 6 added as padding is applied with parent and parent is not getting appended to body
    const height = clone.outerHeight() + 6;
    clone.remove();
    return height;
}

// Show moreLess functionality
let status = 'less';
// eslint-disable-next-line no-unused-vars
function showMoreLess(obj, showMoreDivId) {
    if (status == 'less') {
        obj.addClass('open');
        $('#' + showMoreDivId).find('[rel="showMoreLess"]').removeClass('hide');
        status = 'more';
    } else if (status == 'more') {
        obj.removeClass('open');
        $('#' + showMoreDivId).find('[rel="showMoreLess"]').addClass('hide');
        status = 'less';
    }
}

// Invoking a function to redirect the user to search Result Page
function invokeSearchResult() {
    let searchResultPage = '';
    let textForSearchDeskop = '';
    let textForSearchMobile = '';
    textForSearchDeskop = $('#siteSearch').val();
    textForSearchMobile = $('#siteSearch').val();
    searchResultPage = $('#searchResultPagePath').attr('data-home-text');
    if ($(window).width() >= 320 && $(window).width() <= 767) {
        if (textForSearchMobile != '' && textForSearchMobile != null) {
            window.location.href = searchResultPage + '.html?keyword=' + document.getElementById('siteSearch').value;
        } else if (textForSearchDeskop != '' && textForSearchDeskop != null) {
            window.location.href = searchResultPage + '.html?keyword=' + document.getElementById('siteSearch').value;
        }
    } else if (textForSearchDeskop != '' && textForSearchDeskop != null) {
        window.location.href = searchResultPage + '.html?keyword=' + document.getElementById('siteSearch').value;
    }

}

// User Ratings functionality
let ratingClass;
// eslint-disable-next-line no-unused-vars
function UserRatings() {
    $('input[type="hidden"].ratingVal').each(function() {
        const star = parseFloat($(this).val());
        let beforeDecimal = Math.floor(star);
        let afterDecimal = star - Math.floor(star);
        if (afterDecimal < 0.75) {
            const h = (afterDecimal * 10);
            if (h > 2.5) {
                beforeDecimal = (beforeDecimal + 5 * 0.1) * 10;
            } else {
                beforeDecimal = beforeDecimal * 10;
            }
        } else {
            beforeDecimal = (beforeDecimal + 1) * 10;
        }
        ratingClass = 'rating-' + beforeDecimal;
        $(this).parent().find('span.rating-static').addClass(ratingClass);
    });
}

function searchTypevalue() {
    if ($('#searchResultDigi').length > 0) {
        const searchTypeValue = $('#searchResultDigi').val();
        if (searchTypeValue != null && searchTypeValue != '') {
            if (localStorage) {
                localStorage.setItem('currentSearchType', searchTypeValue);
            }
        }
    }
}

// eslint-disable-next-line no-unused-vars
function showModal(obj, modalId) {
    lastClickedPos = $(window).scrollTop();
    let overlayPagePath = '';
    if (obj.parents != undefined) {
        overlayPagePath = obj.parent().find('input.overlayPath').val();
    } else {
        overlayPagePath = obj.parentNode.children[1].value;
    }
    const url = overlayPagePath;
    let id;
    if (modalId != null && modalId != '') {
        id = modalId;
    } else if (obj.parents != undefined) {
        id = obj.parent().find('input.componentId').val();
    } else {
        id = obj.parentNode.children[2].value;
    }
    if ($('#' + id).length == 0) {
        $.ajax({
            type: 'GET',
            cache: false,
            url: url,
            success: function(msg) {
                $('#modalWindows').html($(msg).find('#' + id));
                slideAndModal(id);
                matchModalHt($('#' + id));
                if (deliveryClickCollect == true) {
                    showClickandCollectPopup(obj);
                }
                if ($('#modalWindows .modal.fade').length > 0 && isMobile) {
                    $('html').addClass('noScroll');
                }
            },
            error: function() {
                // console.log('Unable to load pop-up');
            }
        });
    } else {
        slideAndModal(id);
        matchModalHt($('#' + id));
        if (deliveryClickCollect == true) {
            showClickandCollectPopup(obj);
        }
        if ($('#modalWindows .modal.fade').length > 0 && isMobile) {
            $('html').addClass('noScroll');
        }
    }
    $('.modal-backdrop').one('click', function() {
        $('html').removeClass('noScroll');
    });
}

function showClickandCollectPopup(obj) {
    if (obj.attr('id') == 'collectDlvry' ||
        obj.attr('id') == 'orderWithInStoreCollectInfo' ||
        obj.attr('class') == 'storeDeliveryInfoOverlay') {
        $('#delivery').find('.nav li').removeClass('active').end().find('.nav li:eq(1)').addClass('active');
        $('#delivery').find('.tab-content > div').removeClass('active').end().find('.tab-content > div:eq(1)').addClass('active');
    } else {
        $('#delivery').find('.nav li').removeClass('active').end().find('.nav li:eq(0)').addClass('active');
        $('#delivery').find('.tab-content > div').removeClass('active').end().find('.tab-content > div:eq(0)').addClass('active');
    }
    deliveryClickCollect = false;
}

// eslint-disable-next-line no-unused-vars
function sortAlphaNum(a, b) {
    const aA = a.replace(reA, '');
    const bA = b.replace(reA, '');
    if (aA === bA) {
        const aN = parseInt(a.replace(reN, ''), 10);
        const bN = parseInt(b.replace(reN, ''), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
    }
    return aA > bA ? 1 : -1;
}

function openSideMenuRight(id) {
    $('.overlay').removeClass('hide');
    $(document.body).addClass('ovrflwHid');
    lastClickedPos = $(window).scrollTop();
    $('html,body').animate({
        scrollTop: 0
    }, 'slow');
    $('.sidemenu.right').scrollTop(0);
    $('html,body').addClass('overflowXhide');
    $('.sidemenu#' + id).addClass('open');
}

// eslint-disable-next-line no-unused-vars
function addUrlVars(href, paramName, newVal) {
    // ST2-479 fix starts
    const tmpRegex = new RegExp('(' + paramName + '=).*?(&|$)', 'ig');
    // ST2-479 fix ends
    return href.replace(tmpRegex, '$1' + newVal + '$2');
}

// eslint-disable-next-line no-unused-vars
function removeUrlVars(href, paramName) {
    const customRegex = '&' + paramName + '(=[^&]*)?|^' + paramName + '(=[^&]*)?&?';
    const tmpRegex = new RegExp(customRegex);
    return href.replace(tmpRegex, '');
}

// added to match the height of the overlay sliding from right
function matchModalHt(modalObj) {
    const tabletView = (_w >= 900 && _h >= 600);
    if ($(window).width() < 1024) {
        if (!(navigator.userAgent.match(/iPad/i) != null) && (!(navigator.userAgent.match(/Android/i) == 'Android' && tabletView))) {
            let deviceHt = $(window).height();
            deviceHt = deviceHt - modalObj.find('.modal-header').outerHeight();
            if (!modalObj.find('.modal-body').hasClass('insurncDetail')) {
                modalObj.find('.modal-body').css('height', deviceHt);
            }
        }

        /* Only for modal having tabs */
        let maxTabHt = 0;
        if (modalObj.find('div[role="tabpanel"]').length > 0) {
            const tabParent = modalObj.find('div[role="tabpanel"]');
            tabParent.find('ul.nav > li').each(function() {
                maxTabHt = Math.max(maxTabHt, $(this).outerHeight());
            });
            tabParent.find('ul.nav > li > a').css('height', maxTabHt);
            tabParent.find('ul.nav > li > a > span').each(function() {
                let topMargin = (maxTabHt - $(this).outerHeight()) / 2;
                topMargin = topMargin - 12;
                if (topMargin > 0) {
                    $(this).css('margin-top', topMargin);
                }
            });
        }
    }
}

// detect mobile/tablets
function detectmob() {
    const _w = Math.max($(window).width(), $(window).height());
    const _h = Math.min($(window).width(), $(window).height());
    const tabletView = (_w >= 900 && _h >= 600);

    if ((navigator.userAgent.match(/iPad/i) && window.innerHeight >= 671 && window.innerWidth >= 1024)) {
        return false;
    } else if (window.innerHeight === 927 && window.innerWidth === 768) {
        return true;
    }

    if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ) {

        if (navigator.userAgent.match(/Android/i) == 'Android' && tabletView) {
            if (window.innerHeight < window.innerWidth) {
                return false;
            } else if (window.innerHeight > window.innerWidth) {
                return true;
            }
        } else {
            return true;
        }
    } else {
        return false;
    }
}

// eslint-disable-next-line no-unused-vars
function detectAndroid() {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('android') > -1) {
        return true;
    }
    return false;
}

// Fake localStorage implementation.
// Mimics localStorage, including events.
// It will work just like localStorage, except for the persistant storage part.
const fakeLocalStorage = function() {
    let fakeLocalStorage = {};
    let storage;
    // If Storage exists we modify it to write to our fakeLocalStorage object instead.
    // If Storage does not exist we create an empty object.
    if (window.Storage && window.localStorage) {
        storage = window.Storage.prototype;
    } else {
        // We don't bother implementing a fake Storage object
        window.localStorage = {};
        storage = window.localStorage;
    }
    // For older IE
    if (!window.location.origin) {
        window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }
    const dispatchStorageEvent = function(key, newValue) {
        // `==` to match both null and undefined
        const oldValue = (key == null) ? null : storage.getItem(key);
        const url = location.href.substr(location.origin.length);
        // For IE, http://stackoverflow.com/a/25514935/1214183
        const storageEvent = document.createEvent('StorageEvent');
        storageEvent.initStorageEvent('storage', false, false, key, oldValue, newValue, url, null);
        window.dispatchEvent(storageEvent);
    };
    storage.key = function(i) {
        const key = Object.keys(fakeLocalStorage)[i];
        return typeof key === 'string' ? key : null;
    };
    storage.getItem = function(key) {
        return typeof fakeLocalStorage[key] === 'string' ? fakeLocalStorage[key] : null;
    };
    storage.setItem = function(key, value) {
        dispatchStorageEvent(key, value);
        fakeLocalStorage[key] = String(value);
    };
    storage.removeItem = function(key) {
        dispatchStorageEvent(key, null);
        delete fakeLocalStorage[key];
    };
    storage.clear = function() {
        dispatchStorageEvent(null, null);
        fakeLocalStorage = {};
    };
};
// Use if Fake Local Storage function
if (typeof window.localStorage === 'object') {
    // Safari will throw a fit if we try to use localStorage.setItem in private browsing mode.
    try {
        localStorage.setItem('localStorageTest', 1);
        localStorage.removeItem('localStorageTest');
    } catch (e) {
        fakeLocalStorage();
    }
} else {
    // Use fake localStorage for any browser that does not support it.
    fakeLocalStorage();
}
function read_more_less() {
    const showChar = ($(window).width() < 1024) ? 70 : 100;
    const ellipsesText = '…';
    const readMoreLabel = 'Read More';
    let shortDesc = '';
    let remainDesc = '';
    let fullDeschtml = '';
    let fullDesc = '';
    $('.discover-content__description p').each(function() {
        fullDesc = $(this).html();
        if (fullDesc.length > showChar) {
            shortDesc = fullDesc.substr(0, showChar - 1);
            remainDesc = fullDesc.substr(showChar, fullDesc.length);
            fullDeschtml = shortDesc + '<span class="moreellipses">' + ellipsesText+ '&nbsp;</span><span class="morecontent"><span>' + remainDesc + '</span><a href="javascript:void(0);" class="morelink">' + readMoreLabel + '</a></span>';
            $(this).html(fullDeschtml);
        }
    });
}
function getProperTop(currObj) {
    currObj.parents('.panels').addClass('active');
    const pageName = $('.pageName').val();
    let goToTop;
    if (pageName == 'pdpPage') {
        goToTop = currObj.offset().top - $('.deviceinfoSummary').outerHeight();
    } else {
        goToTop = currObj.offset().top;
    }
    $('html, body').animate({
        scrollTop: goToTop
    }, 'slow');
    currObj.parents('.panels').find('.panelBody').slideDown();
}
function slideAndModal(id) {
    if ($(window).width() < 767) {
        $('#' + id).removeClass('modal').removeClass('fade').addClass('sidemenu').addClass('right').css('display', 'block');
        openSideMenuRight(id);
    } else {
        $('#' + id).removeAttr('style').addClass('modal').addClass('fade').removeClass('sidemenu').removeClass('right');
        $('#' + id).modal();
    }
}
/* Used to replace all occurences of particluar text */
String.prototype.replaceAll = function(target, replacement) {
    return this.split(target).join(replacement);
};
// eslint-disable-next-line no-unused-vars
function performElipsis(text, characterLimit) {
    if (text.length > characterLimit) {
        return text.substring(0, characterLimit) + '…';
    }
    return text;
}
// hide questions if user already attempted the use consent.
const checkConsentCaptured = function() {
    const getSessionData = sessionStorage.getItem('user-consent-captured');

    if (getSessionData) {
        const $userConsent = $('.userConsent');
        const $questions = $userConsent.find('.question > div');

        if ($questions.filter('[data-persist="1"]').length) {
            // remove only non persisted questions
            $questions.not('[data-persist="1"]').remove();
        } else {
            // remove entire GDPR block
            $userConsent.remove();
        }
    }
};
// placement of info icon in html structure.
const consentIconPlacement = function() {
    const getAlliconTags = $('.userConsent .consentTooltip');
    if (getAlliconTags) {
        for (let i = 0; i < getAlliconTags.length; i++) {
            $(getAlliconTags[i]).appendTo($(getAlliconTags[i]).parent('span').find('p:first-child'));
        }
    }
};
// remove duplicate network name from consent question.
// eslint-disable-next-line no-unused-vars
const getUniqueNetworkName = function(networkList) {
    const names = networkList.split(',');
    const uniqueNames = [];
    $.each(names, function(i, el) {
        if ($.inArray(el.trim(), uniqueNames) === -1) {
            uniqueNames.push(el.trim());
        }
    });
    return uniqueNames;
};
checkConsentCaptured();
consentIconPlacement();
$(window).load(function() {
    const buttonElement = document.querySelector(".add-to-basket-buyNowbtn");
    if (buttonElement) {
        const buttonText = buttonElement.innerText.trim();
        if (buttonText === "Buy Now") {
            const element = document.querySelector(".pd-tb-paym");
            $(window).resize(function() {
                const windowWidth = $(window).width();
                if (windowWidth < 768) {
                    element.classList.add("buybuttonheight");
                   // $(".buybuttonheight").css("height", "120px");  commenting because of ECCEL-611
                } else {
                    element.classList.add("buybuttonheight");
                    $(".buybuttonheight").css("height", "");
                }
            });
        
        }
    }
});
$(window).resize(function() {
    debounceExtras();
});
function debounceExtras() {
    if ($('.extra-acc-promo').length) {
        let extraAccPromoCnt = $('.extra-acc-promo').length;
        let totalCnt = 0;
        let accCnt = 0;
        let increaseHeight = 0;
        let tileCls = [];
        if (window.innerWidth > 767) {
            $('.extra-acc-promo').each(function() {
                totalCnt = parseInt(totalCnt) + parseInt(1);
                let $this = $(this);
                let dataRef = $this.attr('data-ref');
                if (accCnt == 3) {
                    accCnt = 0;
                    extraAccPromo = 0;
                    increaseHeight = 0;
                    tileCls = [];
                }
                accCnt = parseInt(accCnt) + parseInt(1);
                tileCls.push('extraAccPromo' + dataRef);
                let extraAccPromo = 0;
                $('.extras-promo').each(function() {
                    // if ($(this).attr('data-ref') == dataRef && $(this).outerHeight(true) >= extraAccPromo) {
                    if ($(this).attr('data-ref') == dataRef) {
                        extraAccPromo = parseInt(extraAccPromo) + parseInt($(this).outerHeight(true));
                    }
                });
                if (extraAccPromo > increaseHeight) {
                    increaseHeight = extraAccPromo;
                }
                if ((accCnt == 3 || totalCnt == extraAccPromoCnt) && increaseHeight > 0 && tileCls.length > 0) {
                    tileCls.forEach(tileClsRef => {
                        $('.' + tileClsRef).attr('style', 'min-height: ' + increaseHeight + 'px !important');
                    });
                }
            });
        } else {
            $('.extra-acc-promo').attr('style', 'min-height: auto !important');
        }
    }
}
function showHidePriceDrip(show, hide) {
    if (show != '' && hide != '') {
        if ($('.' + show).length) {
            if ($('.' + show).hasClass('hide')) {
                $('.' + show).removeClass('hide');
            }
        }
        if ($('.' + hide).length) {
            if (!$('.' + hide).hasClass('hide')) {
                $('.' + hide).addClass('hide');
            }
        }
    } else {
        if ($('.PaymPriceDrip').length) {
            if (!$('.PaymPriceDrip').hasClass('hide')) {
                $('.PaymPriceDrip').addClass('hide');
            }
        }
        if ($('.PaymUpgradePriceDrip').length) {
            if (!$('.PaymUpgradePriceDrip').hasClass('hide')) {
                $('.PaymUpgradePriceDrip').addClass('hide');
            }
        }
    }
    if (show != '' && hide != '') {
        if ($('.' + show).length) {
            if ($('.' + show).hasClass('hide')) {
                $('.' + show).removeClass('hide');
            }
        } else if (!$('.handsetContractOptionDiscount').hasClass('hide')) {
            $('.handsetContractOptionDiscount').addClass('hide');
        }
    }
}
function showHidePromotionTag(show, hideOne, hideTwo) {
    if ($('.' + show).length && $('.' + show).hasClass('hide')) {
        $('.' + show).removeClass('hide');
    }
    if ($('.' + hideOne).length && !$('.' + hideOne).hasClass('hide')) {
        $('.' + hideOne).addClass('hide');
    }
    if ($('.' + hideTwo).length && !$('.' + hideTwo).hasClass('hide')) {
        $('.' + hideTwo).addClass('hide');
    }
}
function showHideHiddenTag(show, hideOne, hideTwo) {
    if ($('.hiddenDealTag' + show).length && $('.hiddenDealTag' + show).hasClass('hide')) {
        $('.hiddenDealTag' + show).removeClass('hide');
    }
    if ($('.hiddenDealTag' + hideOne).length && !$('.hiddenDealTag' + hideOne).hasClass('hide')) {
        $('.hiddenDealTag' + hideOne).addClass('hide');
    }
    if ($('.hiddenDealTag' + hideTwo).length && !$('.hiddenDealTag' + hideTwo).hasClass('hide')) {
        $('.hiddenDealTag' + hideTwo).addClass('hide');
    }
}
const checkZoomLevel = () => {
    const zoomLevel = Math.round((window.outerWidth / window.innerWidth) * 100) / 100;
    if ((zoomLevel >= 0.25 && zoomLevel <= 0.5)) {
        if (!$('.productInfoHandsetDivider').hasClass('productInfoHandsetDividerheight')) {
            $('.productInfoHandsetDivider').addClass('productInfoHandsetDividerheight');
        }
    } else {
        if ($('.productInfoHandsetDivider').hasClass('productInfoHandsetDividerheight')) {
            $('.productInfoHandsetDivider').removeClass('productInfoHandsetDividerheight');
        }
    }
};
if ($('.detailsHandset').length) {
    window.addEventListener('resize', checkZoomLevel);
    window.addEventListener('load', checkZoomLevel);
}
const checkViewPortForTradeIn = () => {
    if ($('.tradeInHandset').length && !$('.tradeInHandset').hasClass('tradeInAccessory')) {
        const width = window.innerWidth;
        const isMobile = width <= 767;
        const isTablet = width > 767 && width <= 1023;
        const isDesktop = width >= 1024;
        if (isMobile || isTablet) {
            $('.has-trade-in-desktop').remove();
        }
        if (isDesktop) {
            $('.has-trade-in-mobile').remove();
        }
    }
};
checkViewPortForTradeIn();
window.addEventListener('resize', checkViewPortForTradeIn);
window.addEventListener('load', checkViewPortForTradeIn);
/* PDP JS FUNCTIONALITIES ENDS */
/* CPW MANAGING COOKIES THROUGH JS STARTS */
function handleHrefUrl($this) {
    let href = $this.attr('href');
    let orgHref = $this.attr('data-org-url');
    let handleProdIdUrlCheck = true;
    let changeUrlCheck = true;
    if (getCookie('hiddenAffiliateId') == '') {
        if ($('#pdpDealData').length) {
            let pdpDealData = JSON.parse($('#pdpDealData').val());
            if (pdpDealData.prodIdUrl != '' && pdpDealData.isHidden == 'true') {
                if (!('cookieSet' in pdpDealData)) {
                    pdpDealData.cookieSet = 'yes';
                    $('#pdpDealData').val(JSON.stringify(pdpDealData));
                    setHiddenAffiliateIdCookie(pdpDealData);
                    handleProdIdUrlCheck = false;
                    changeUrlCheck = false;
                }
            }
        }
    } else {
        changeUrlCheck = false;
    }
    if (handleProdIdUrlCheck) {
        handleProdIdUrl();
        if (changeUrlCheck && href != orgHref) {
            $this.attr('href', orgHref);
            revertDealDetails();
        }
    }
}
function setHiddenAffiliateIdCookie(pdpDealData) {
    if (getCookie('hiddenAffiliateId') == '') {
        const data = {
            'path': pdpDealData.prodIdUrl,
            'product': pdpDealData.prodIdProduct,
            'dealType': pdpDealData.dealType,
            'color': pdpDealData.prodIdColour,
            'family': pdpDealData.prodIdFamily,
            'capacity': pdpDealData.prodIdCapacity,
            'familyId': pdpDealData.prodIdFamilyId,
            'isHidden': pdpDealData.isHidden,
            'monthlyPrice': pdpDealData.monthlyPrice,
            'dealPrice': pdpDealData.dealPrice,
            'contractLength': pdpDealData.contractLength,
            'network': pdpDealData.network,
            'productSimType': pdpDealData.productSimType,
            'productPhoneType': pdpDealData.productPhoneType,
            'refurbished': pdpDealData.refurbished,
            'refurbishedGrade': pdpDealData.refurbishedGrade,
            'giftName': pdpDealData.giftName,
            'productType': pdpDealData.productType,
            'tariffData': pdpDealData.tariffData,
            'tariffMinutes': pdpDealData.tariffMinutes,
            'tariffTexts': pdpDealData.tariffTexts,
            'hstarid': pdpDealData.hstarid,
            'ofComData': pdpDealData.ofComData,
            'tariffCode': pdpDealData.tariffCode,
            'giftCode': pdpDealData.giftCode,
            'productCode': pdpDealData.productCode,
            'productUrlNameSlug': pdpDealData.productUrlNameSlug,
            'dealPieId': pdpDealData.dealPieId
        };
        const cookieName = 'hiddenAffiliateId';
        const cookieValue = btoa(JSON.stringify(data));
        const expiryDate = new Date(Date.now() + 30 * 60 * 1000);
        document.cookie = `${cookieName}=${encodeURIComponent(cookieValue)}; expires=${expiryDate.toUTCString()}; path=/`;
        if (!('cookieSet' in pdpDealData)) {
            pdpDealData.cookieSet = 'yes';
            $('#pdpDealData').val(JSON.stringify(pdpDealData));
        }
    }
    handleProdIdUrl();
}
function handleProdIdUrl() {
    let hiddenAffiliateId = getCookie('hiddenAffiliateId');
    if (hiddenAffiliateId && hiddenAffiliateId != '') {
        hiddenAffiliateId = JSON.parse(atob(decodeURIComponent(hiddenAffiliateId)));
        if ($('.color-capacity-href').length) {
            $('.color-capacity-href').each(function() {
                let dataRef = $(this).attr('data-ref');
                let dataVal = $(this).attr('data-' + dataRef);
                if ($('#pdpDealData').length) {
                    let pdpDealData = JSON.parse($('#pdpDealData').val());
                    if (!('cookieSet' in pdpDealData)) {
                        pdpDealData.cookieSet = 'yes';
                        $('#pdpDealData').val(JSON.stringify(pdpDealData));
                    }
                    if ((hiddenAffiliateId.familyId == pdpDealData.prodIdFamilyId || hiddenAffiliateId.family == pdpDealData.prodIdFamily) && hiddenAffiliateId.dealType == pdpDealData.dealType) {
                        const url = new URL(window.location.href);
                        const params = url.searchParams;
                        if (params.has('prod_id')) params.delete('prod_id');
                        if (params.has('tariffcode')) params.delete('tariffcode');
                        if (params.has('giftcode')) params.delete('giftcode');
                        if (params.has('productcode')) params.delete('productcode');
                        if (params.has('preferred_variation_tariffcode_paym')) params.delete('preferred_variation_tariffcode_paym');
                        if (params.has('preferred_variation_tariffcode_paymupgrade')) params.delete('preferred_variation_tariffcode_paymupgrade');
                        if (params.has('preferred_variation_tariffcode_simfree')) params.delete('preferred_variation_tariffcode_simfree');
                        if ((dataRef == 'colour' && dataVal == hiddenAffiliateId.color && hiddenAffiliateId.capacity == pdpDealData.prodIdCapacity) || (dataRef == 'capacity' && dataVal == hiddenAffiliateId.capacity && hiddenAffiliateId.color == pdpDealData.prodIdColour)) {
                            $(this).attr('href', hiddenAffiliateId.path + ((params.toString() != '') ? '&' : '') + params.toString());
                        }
                    }
                } else {
                    let plpDealData = JSON.parse($(this).attr('data-plp'));
                    if ((hiddenAffiliateId.familyId == plpDealData.prodIdFamilyId || hiddenAffiliateId.family == plpDealData.prodIdFamily) && hiddenAffiliateId.dealType == plpDealData.dealType && hiddenAffiliateId.color == plpDealData.prodIdColour && hiddenAffiliateId.capacity == plpDealData.prodIdCapacity) {
                        if (checkHiddenUrlStaisfied(hiddenAffiliateId, 'filter_network[]') && checkHiddenUrlStaisfied(hiddenAffiliateId, 'filter_sim_type[]') && checkHiddenUrlStaisfied(hiddenAffiliateId, 'filter_product_phone_type[]') && checkHiddenUrlStaisfied(hiddenAffiliateId, 'filter_gift_name_split[]') && checkHiddenUrlStaisfied(hiddenAffiliateId, 'filter_is_refurbished') && checkHiddenUrlStaisfied(hiddenAffiliateId, 'filter_contract_length[]') && checkHiddenUrlStaisfied(hiddenAffiliateId, 'filter_monthly_cost[]') && checkHiddenUrlStaisfied(hiddenAffiliateId, 'filter_monthly_cost_sim[]') && checkHiddenUrlStaisfied(hiddenAffiliateId, 'filter_upfront_cost[]') && checkHiddenUrlStaisfied(hiddenAffiliateId, 'filter_tariff_data[]') && checkHiddenUrlStaisfied(hiddenAffiliateId, 'chk_deal_effectivecost_min') && checkHiddenUrlStaisfied(hiddenAffiliateId, 'chk_deal_price_min')) {
                            $(this).attr('href', hiddenAffiliateId.path + ((window.location.search.slice(1) != '') ? '&' + window.location.search.slice(1) : '') + getUpgradeFilterUrl());
                            // applyDealDetailsChange(hiddenAffiliateId, dataRef);
                        }
                    }
                }
            });
        }
    }
}
function getUpgradeFilterUrl() {
    let refererPath = window.location.pathname;
    const queryParams = window.location.search.slice(1);
    const hasNetworkFilter =
        queryParams.includes('filter_network_multiselect') ||
        queryParams.includes('filter_network');
    let networkValue = (refererPath.includes('/upgrades/idmobile')) ? 'idmobile' : ((refererPath.includes('/upgrades/vodafone')) ? 'vodafone' : '');
    return (networkValue && networkValue != '' && !hasNetworkFilter) ? `&filter_network_multiselect[]=${networkValue}` : '';
}
function revertDealDetails() {
    // if ($('.color-capacity-href').length) {
    //     $('.color-capacity-href').each(function() {
    //         let dataRef = $(this).attr('data-ref');
    //         if (!$('#pdpDealData').length) {
    //             let plpDealData = JSON.parse($(this).attr('data-plp'));
    //             applyDealDetailsChange(plpDealData, dataRef);
    //         }
    //     });
    // }
}
function applyDealDetailsChange(plpDealData, dataRef) {    
    if ($('.dealPicture' + dataRef).length) {
        $('.dealPicture' + dataRef).html('\
            <source type="image/webp" srcset="https://media.secure-mobiles.com/network-logos/listing/' + plpDealData.network + '.webp">\
            <img loading="lazy" src="https://media.secure-mobiles.com/network-logos/listing/' + plpDealData.network + '.png" title="' + plpDealData.network + '" alt="' + plpDealData.network + '">\
        ');
    }
    if ($('.lowMonthlyPrice' + dataRef).length) {
        $('.lowMonthlyPrice' + dataRef).html('£' + plpDealData.monthlyPrice.toFixed(2));
    }
    if ($('.lowUpfrontPrice' + dataRef).length) {
        $('.lowUpfrontPrice' + dataRef).html('£' + plpDealData.dealPrice.toFixed(2));
    }
    if ($('.dataShow' + dataRef).length) {
        $('.dataShow' + dataRef).html((plpDealData.tariffData != '-1') ? formatBytes(plpDealData.tariffData) : 'Unlimited');
    }
    if ($('.minsAndTextsShow' + dataRef).length) {
        $('.minsAndTextsShow' + dataRef).html('<strong>' + ((plpDealData.tariffMinutes == '-1') ? 'Unlimited' : plpDealData.tariffMinutes) + '</strong> Mins & ' + ((plpDealData.tariffMinutes != plpDealData.tariffMinutes) ? ((plpDealData.tariffTexts == '-1') ? 'Unlimited ' : plpDealData.tariffTexts + ' ') : '') + 'Texts');
    }
    if ($('.giftShow' + dataRef).length) {
        if (plpDealData.giftName != '' && plpDealData.giftName != 'N/A') {
            $('.giftShow' + dataRef).html('\
                ' + ((hasCashbackOrTopup(plpDealData.giftName) == false) ? '<span class="free-gift-text">FREE</span>' : '') + '\
                ' + plpDealData.giftName.replace('Â£', '£') + '\
            ');
        }
    } else {
        if (plpDealData.giftName != '' && plpDealData.giftName != 'N/A' && $('.giftPriceContainer' + dataRef).length) {
            $('.giftPriceContainer' + dataRef).after('\
                <span class="free-gift giftShow' + dataRef + '">\
                ' + ((hasCashbackOrTopup(plpDealData.giftName) == false) ? '<span class="free-gift-text">FREE</span>' : '') + '\
                ' + plpDealData.giftName.replace('Â£', '£') + '\
                </span>\
            ');
        }
    }
    if (plpDealData.ofComData.hasOwnProperty('no_of_increase') && plpDealData.ofComData.no_of_increase > 0) {
        let ofcomHtml = getOfcomHtml(plpDealData, dataRef);
        document.querySelectorAll('.ofcomShow' + dataRef).forEach(el => el.remove());
        if (ofcomHtml != ''){
            if ($('.giftShow' + dataRef).length) {
                $('.giftShow' + dataRef).after(ofcomHtml);
            } else {
                if ($('.giftPriceContainer' + dataRef).length) {
                    $('.giftPriceContainer' + dataRef).after(ofcomHtml);
                }
            }
        }
    }
    if ($('.viewDeals' + dataRef).length) {
        $('.viewDeals' + dataRef).attr('href', '/' + plpDealData.productUrlNameSlug + '/deals?tariffcode=' + plpDealData.tariffCode + '&giftcode=' + plpDealData.giftCode + '&productcode=' + plpDealData.productCode + '&preferred_variation_tariffcode_' + plpDealData.dealType + '=' + plpDealData.tariffCode + ((plpDealData.isHidden == 'true') ? '&hiddenFlag=true&prodId=' + plpDealData.dealPieId : ''));
    }
    if ($('.buyNow' + dataRef).length) {
        $('.buyNow' + dataRef).attr('href', '/buy/' + plpDealData.hstarid + '/' + plpDealData.giftCode + '?redirectPath=/extras/insurance?tariffcode=' + plpDealData.tariffCode + '&giftcode=' + plpDealData.giftCode + '&productcode=' + plpDealData.productCode);
    }
}
function getOfcomHtml(hiddenAffiliateId, dataRef) {
    let ofComData = hiddenAffiliateId.ofComData;
    let returnHtml = '';
    if (!ofComData.deleted && ofComData.no_of_increase > 0) {
        let ofComClass = (hiddenAffiliateId.getNetwork == 'idmobile') ? 'ofcom-text' : 'ofcom-text-vod';
        returnHtml = '\
            <span class="ofcom-rectangle ofcomShow' + dataRef + '"></span>\
            <span class="monthly-price-increasing-to ofcomShow' + dataRef + '">Monthly price increasing to:</span>\
            <div class="card-tile-footer-ofcom ofcomShow' + dataRef + '">\
        ';
        if (ofComData.no_of_increase >= 2) {
            returnHtml += '\
                <div class="gift-price-container-ofcom">\
                    <span class="' + ofComClass + '">\
                        <span class="item-details-ofcom-price-font-trade-bold">£' + ofComData.mrc1_amount + '</span>\
                        <span class="ofcom-text-from">from</span>\
                        <span class="item-details-ofcom-price-font-trade-bold">\
                            ' + ofComData.mrc1_start_date_date + '<sup class="sup-fs">' + ofComData.mrc1_start_date_sup.toUpperCase() + '</sup>\
                        </span>\
                        <span class="item-details-ofcom-price-font">' + ofComData.mrc1_start_date_mon + '</span>\
                        <span class="item-details-ofcom-price-font-trade-bold">' + ofComData.mrc1_start_date_year + '</span>\
                    </span>\
                    <span class="' + ofComClass + '">\
                        <span class="item-details-ofcom-price-font-trade-bold">£' + ofComData.mrc2_amount + '</span>\
                        <span class="ofcom-text-from">from</span>\
                        <span class="item-details-ofcom-price-font-trade-bold">\
                            ' + ofComData.mrc2_start_date_date + '<sup class="sup-fs">' + ofComData.mrc2_start_date_sup.toUpperCase() + '</sup>\
                        </span>\
                        <span class="item-details-ofcom-price-font">' + ofComData.mrc2_start_date_mon + '</span>\
                        <span class="item-details-ofcom-price-font-trade-bold">' + ofComData.mrc2_start_date_year + '</span>\
                    </span>\
                </div>\
            ';
        }
        if (ofComData.no_of_increase == 4) {
            returnHtml += '\
                <div class="gift-price-container-ofcom">\
                    <span class="' + ofComClass + '">\
                        <span class="item-details-ofcom-price-font-trade-bold">£' + ofComData.mrc3_amount + '</span>\
                        <span class="ofcom-text-from">from</span>\
                        <span class="item-details-ofcom-price-font-trade-bold">\
                            ' + ofComData.mrc3_start_date_date + '<sup class="sup-fs">' + ofComData.mrc3_start_date_sup.toUpperCase() + '</sup>\
                        </span>\
                        <span class="item-details-ofcom-price-font">' + ofComData.mrc3_start_date_mon + '</span>\
                        <span class="item-details-ofcom-price-font-trade-bold">' + ofComData.mrc3_start_date_year + '</span>\
                    </span>\
                    <span class="' + ofComClass + '">\
                        <span class="item-details-ofcom-price-font-trade-bold">£' + ofComData.mrc4_amount + '</span>\
                        <span class="ofcom-text-from">from</span>\
                        <span class="item-details-ofcom-price-font-trade-bold">\
                            ' + ofComData.mrc4_start_date_date + '<sup class="sup-fs">' + ofComData.mrc4_start_date_sup.toUpperCase() + '</sup>\
                        </span>\
                        <span class="item-details-ofcom-price-font">' + ofComData.mrc4_start_date_mon + '</span>\
                        <span class="item-details-ofcom-price-font-trade-bold">' + ofComData.mrc4_start_date_year + '</span>\
                    </span>\
                </div>\
            ';
        }
        if (ofComData.no_of_increase == 1 || ofComData.no_of_increase == 3) {
            returnHtml += '\
                <div class="gift-price-container-ofcom">\
                    <span class="' + ofComClass + '">\
                        <span class="item-details-ofcom-price-font-trade-bold">£' + ((ofComData.no_of_increase == 3) ? ofComData.mrc3_amount : ofComData.mrc1_amount) + '</span>\
                        <span class="ofcom-text-from">from</span>\
                        <span class="item-details-ofcom-price-font-trade-bold">\
                            ' + ((ofComData.no_of_increase == 3) ? ofComData.mrc3_start_date_date : ofComData.mrc1_start_date_date) + '<sup class="sup-fs">' + ((ofComData.no_of_increase == 3) ? ofComData.mrc3_start_date_sup.toUpperCase() : ofComData.mrc1_start_date_sup.toUpperCase()) + '</sup>\
                        </span>\
                        <span class="item-details-ofcom-price-font">' + ((ofComData.no_of_increase == 3) ? ofComData.mrc3_start_date_mon : ofComData.mrc1_start_date_mon) + '</span>\
                        <span class="item-details-ofcom-price-font-trade-bold">' + ((ofComData.no_of_increase == 3) ? ofComData.mrc3_start_date_year : ofComData.mrc1_start_date_year) + '</span>\
                    </span>\
                </div>\
            ';
        }
        returnHtml += '</div>';
    }
    return returnHtml;
}
function hasCashbackOrTopup(giftData) {
    const pattern = /cashback|chequeback|required/i;
    return pattern.test(giftData); // returns true or false
}
function checkHiddenUrlStaisfied(hiddenData, filterKey) {
    let returnData = true;
    if (filterKey == 'filter_is_refurbished' && $('#filter_is_refurbished').length) {
        returnData = (hiddenData.refurbished == ($('#filter_is_refurbished').prop('checked') == true) ? 'true' : 'false') ? true : false;
    } else if (filterKey == 'chk_deal_effectivecost_min' && $('#chk_deal_effectivecost_min').length) {
        if($('#chk_deal_effectivecost_min').val() != '' || $('#chk_deal_effectivecost_max').val() != '') {
            returnData = false;
            if($('#chk_deal_effectivecost_min').val() != '' && $('#chk_deal_effectivecost_max').val() != '') {
                if (returnFloatVal(hiddenData.monthlyPrice) >= returnFloatVal($('#chk_deal_effectivecost_min').val()) && returnFloatVal(hiddenData.monthlyPrice) <= returnFloatVal($('#chk_deal_effectivecost_max').val())) {
                    returnData = true;
                }
            } else if($('#chk_deal_effectivecost_min').val() != '' && $('#chk_deal_effectivecost_max').val() == '') {
                if (returnFloatVal(hiddenData.monthlyPrice) >= returnFloatVal($('#chk_deal_effectivecost_min').val())) {
                    returnData = true;
                }
            } else if($('#chk_deal_effectivecost_min').val() == '' && $('#chk_deal_effectivecost_max').val() != '') {
                if (returnFloatVal(hiddenData.monthlyPrice) <= returnFloatVal($('#chk_deal_effectivecost_max').val())) {
                    returnData = true;
                }
            }
        }
    } else if (filterKey == 'chk_deal_price_min' && $('#chk_deal_price_min').length) {
        if($('#chk_deal_price_min').val() != '' || $('#chk_deal_price_max').val() != '') {
            returnData = false;
            if($('#chk_deal_price_min').val() != '' && $('#chk_deal_price_max').val() != '') {
                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal($('#chk_deal_price_min').val()) && returnFloatVal(hiddenData.dealPrice) <= returnFloatVal($('#chk_deal_price_max').val())) {
                    returnData = true;
                }
            } else if($('#chk_deal_price_min').val() != '' && $('#chk_deal_price_max').val() == '') {
                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal($('#chk_deal_price_min').val())) {
                    returnData = true;
                }
            } else if($('#chk_deal_price_min').val() == '' && $('#chk_deal_price_max').val() != '') {
                if (returnFloatVal(hiddenData.dealPrice) <= returnFloatVal($('#chk_deal_price_max').val())) {
                    returnData = true;
                }
            }
        }
    } else {
        if ( $('.cpwInputFilter').length) {
            $('.cpwInputFilter').each(function() {
                if ($(this).attr('name') == filterKey && $(this).prop('checked') == true) {
                    returnData = false;
                    if (filterKey == 'filter_product_phone_type[]') {
                        if (hiddenData.productPhoneType.includes($(this).val())) {
                            returnData = true;
                            return false;
                        }
                    } else if (filterKey == 'filter_gift_name_split[]') {
                        if (hiddenData.giftName.toLowerCase().includes($(this).val().toLowerCase())) {
                            returnData = true;
                            return false;
                        }
                    } else if (filterKey == 'filter_monthly_cost[]' || filterKey == 'filter_monthly_cost_sim[]') {
                        switch ($(this).val()) {
                            case ">=10-<20":
                                if (returnFloatVal(hiddenData.monthlyPrice) >= returnFloatVal(10) && returnFloatVal(hiddenData.monthlyPrice) < returnFloatVal(20)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=20-<40":
                                if (returnFloatVal(hiddenData.monthlyPrice) >= returnFloatVal(20) && returnFloatVal(hiddenData.monthlyPrice) < returnFloatVal(40)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=40-<50":
                                if (returnFloatVal(hiddenData.monthlyPrice) >= returnFloatVal(40) && returnFloatVal(hiddenData.monthlyPrice) < returnFloatVal(50)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=1-<10":
                                if (returnFloatVal(hiddenData.monthlyPrice) >= returnFloatVal(1) && returnFloatVal(hiddenData.monthlyPrice) < returnFloatVal(10)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=50":
                                if (returnFloatVal(hiddenData.monthlyPrice) >= returnFloatVal(50)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=40":
                                if (returnFloatVal(hiddenData.monthlyPrice) >= returnFloatVal(40)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            default:
                                returnData = true;
                                return false;
                        }
                    } else if (filterKey == 'filter_upfront_cost[]') {
                        switch ($(this).val()) {
                            case "0.00":
                                if (returnFloatVal(hiddenData.dealPrice) == returnFloatVal(0)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=1-<10":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(1) && returnFloatVal(hiddenData.dealPrice) < returnFloatVal(10)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=1-<20":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(1) && returnFloatVal(hiddenData.dealPrice) < returnFloatVal(20)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=1-<50":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(1) && returnFloatVal(hiddenData.dealPrice) < returnFloatVal(50)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=1-<250":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(1) && returnFloatVal(hiddenData.dealPrice) < returnFloatVal(250)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=10-<30":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(10) && returnFloatVal(hiddenData.dealPrice) < returnFloatVal(30)) {
                                    returnData = true;
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=20-<30":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(20) && returnFloatVal(hiddenData.dealPrice) < returnFloatVal(30)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=20-<50":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(20) && returnFloatVal(hiddenData.dealPrice) < returnFloatVal(50)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=30-<50":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(30) && returnFloatVal(hiddenData.dealPrice) < returnFloatVal(50)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=50-<100":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(50) && returnFloatVal(hiddenData.dealPrice) < returnFloatVal(100)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=50-<150":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(50) && returnFloatVal(hiddenData.dealPrice) < returnFloatVal(150)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=100-<200":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(100) && returnFloatVal(hiddenData.dealPrice) < returnFloatVal(200)) {
                                    returnData = true;
                                    return false;
                                }
                                break;

                            case ">=20":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(20)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=30":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(30)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=50":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(50)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=100":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(100)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=150":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(150)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=200":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(200)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=1000":
                                if (returnFloatVal(hiddenData.dealPrice) >= returnFloatVal(1000)) {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            default:
                                returnData = true;
                                return false;
                        }
                    } else if (filterKey == 'filter_tariff_data[]') {
                        switch ($(this).val()) {
                            case "1000-19000":
                                if (hiddenData.tariffData >= '1000' && hiddenData.tariffData < '19000') {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case "20000-49000":
                                if (hiddenData.tariffData >= '20000' && hiddenData.tariffData < '49000') {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case "50000-99000":
                                if (hiddenData.tariffData >= '50000' && hiddenData.tariffData < '99000') {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case ">=100000":
                                if (hiddenData.tariffData >= '100000') {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            case "-1":
                                if (hiddenData.tariffData == '-1') {
                                    returnData = true;
                                    return false;
                                }
                                break;
                            default:
                                returnData = true;
                                return false;
                        }
                    } else if (filterKey == 'filter_sim_type[]') {
                        if ($(this).val() == hiddenData.productSimType) {
                            returnData = true;
                            return false;
                        }
                    } else if (filterKey == 'filter_contract_length[]') {
                        if ($(this).val() == hiddenData.contractLength) {
                            returnData = true;
                            return false;
                        }
                    } else {
                        if ($(this).val() == hiddenData.network) {
                            returnData = true;
                            return false;
                        }
                    }            
                }
            });
        }
    }
    return returnData;
}
function returnFloatVal(returnVal) {
    return parseFloat(parseFloat(returnVal).toFixed(2));
}
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return '';
}
function formatBytes(bytes) {
    const units = ['MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Bytes';
    const i = Math.floor(Math.log(bytes) / Math.log(1000));
    const value = bytes / Math.pow(1000, i);
    return `${value}${units[i]}`;
}
function handlePdpBreadCrumbsCta() {
    if ($('.plpBreadCrumbsCta').length) {
        let href = $('.plpBreadCrumbsCta').attr('href');
        const urlParams = new URLSearchParams(window.location.search);
        const urlQuery = {};
        for (let [key, value] of urlParams.entries()) {
            key = key.replace(/\[.*?\]/g, '');
            urlQuery[key] = (urlQuery[key]) ? [].concat(urlQuery[key], value) : value;
        }
        const excludeQuery = ['tariffcode', 'giftcode', 'productcode', 'sort', 'prod_id', 'preferred_variation_tariffcode_paymupgrade', 'preferred_variation_tariffcode_paym', 'preferred_variation_tariffcode_simfree'];
        const filterAliases = {
            filter_network_multiselect: 'network',
            filter_network: 'network'
        };
        const CPW_FILTERS_MAP = {
            'filter_network_multiselect': 'filter_network',
            'filter_product_phone_type_simfree': 'filter_product_phone_type',
            'filter_upfront_cost_sim_free': 'filter_upfront_cost',
            'filter_upfront_cost_sim_free_min': 'filter_upfront_cost_min',
            'filter_upfront_cost_sim_free_max': 'filter_upfront_cost_max',
            'filter_upfront_cost_cases': 'filter_upfront_cost_non_contract',
            'filter_upfront_cost_screen_protector': 'filter_upfront_cost_non_contract',
            'filter_upfront_cost_chargers': 'filter_upfront_cost_non_contract',
            'filter_upfront_cost_powerbanks': 'filter_upfront_cost_non_contract',
            'filter_network_multiselect[]': 'filter_network[]',
            'filter_product_phone_type_simfree[]': 'filter_product_phone_type[]',
            'filter_upfront_cost_sim_free[]': 'filter_upfront_cost[]',
            'filter_upfront_cost_cases[]': 'filter_upfront_cost_non_contract[]',
            'filter_upfront_cost_screen_protector[]': 'filter_upfront_cost_non_contract[]',
            'filter_upfront_cost_chargers[]': 'filter_upfront_cost_non_contract[]',
            'filter_upfront_cost_powerbanks[]': 'filter_upfront_cost_non_contract[]'
        };
        const CPW_FILTERS_SINGLE = {
            'filter_monthly_cost_min': 'filter_monthly_cost_min',
            'filter_monthly_cost_max': 'filter_monthly_cost_max',
            'filter_upfront_cost_min': 'filter_upfront_cost_min',
            'filter_upfront_cost_max': 'filter_upfront_cost_max',
            'filter_is_refurbished': 'filter_is_refurbished',
            'filter_out_of_stock': 'filter_out_of_stock',
            'preferred_variation_tariffcode_paymupgrade': 'preferred_variation_tariffcode_paymupgrade',
            'preferred_variation_tariffcode_paym': 'preferred_variation_tariffcode_paym',
            'preferred_variation_tariffcode_simfree': 'preferred_variation_tariffcode_simfree'
        };
        let queryString = '';
        let extraQueryString = '';
        // Handle excluded keys
        excludeQuery.forEach(exclude => {
            if (urlQuery.hasOwnProperty(exclude)) {
                if (exclude === 'sort') {
                    queryString = `?sort=${urlQuery[exclude]}`;
                }
                delete urlQuery[exclude];
            }
        });
        // Check for only brand
        const onlyBrand = Object.keys(urlQuery).length === 1 &&
            urlQuery.hasOwnProperty('filter_brand_featured') &&
            Array.isArray(urlQuery['filter_brand_featured']) &&
            urlQuery['filter_brand_featured'].length === 1;
        if (onlyBrand) {
            queryString = `/${urlQuery['filter_brand_featured'][0].toLowerCase()}${queryString || ''}`;
            delete urlQuery['filter_brand_featured'];
        }
        // Determine product subtype from referer
        const referer = document.referrer;
        let productSubType = '';
        if (referer.includes('/cases')) productSubType = 'Case';
        else if (referer.includes('/screen-protector')) productSubType = 'Screen Protector';
        else if (referer.includes('/headphones')) productSubType = 'Headphones';
        else if (referer.includes('/chargers')) productSubType = 'Charger';
        else if (referer.includes('/powerbanks')) productSubType = 'Power Bank';
        if (productSubType) {
            queryString += queryString ? `&filter_product_subtype[]=${productSubType}` : `?filter_product_subtype[]=${productSubType}`;
        }
        // Normalize and deduplicate filters
        const existingKeys = [];
        const dedupedQuery = {};
        const normalizedKeys = [];
        let operator = '';
        Object.keys(urlQuery).forEach(key => {
            const normalized = filterAliases[key] || key;
            if (!existingKeys.includes(normalized.replace(/\[.*?\]/g, ''))) {
                existingKeys.push(normalized.replace(/\[.*?\]/g, ''));
            }
        });
        Object.entries(urlQuery).forEach(([key, value]) => {
            const normalized = filterAliases[key] || key;
            if (!normalizedKeys.includes(normalized.replace(/\[.*?\]/g, ''))) {
                dedupedQuery[key.replace(/\[.*?\]/g, '')] = value;
                normalizedKeys.push(normalized.replace(/\[.*?\]/g, ''));
            }
        });
        // Build extra query string
        Object.entries(dedupedQuery).forEach(([filterKey, filterVal]) => {
            const keyToPut = CPW_FILTERS_MAP[filterKey] || filterKey;
            if (Array.isArray(filterVal)) {
                filterVal.forEach(val => {
                    extraQueryString += extraQueryString ? `&${keyToPut}[]=${val}` : `${keyToPut}[]=${val}`;
                });
            } else {
                operator = (keyToPut in CPW_FILTERS_SINGLE) ? '' : '[]';
                extraQueryString += extraQueryString ? `&${keyToPut}${operator}=${filterVal}` : `${keyToPut}${operator}=${filterVal}`;
            }
        });
        if (extraQueryString) {
            queryString = queryString ? `${queryString}&${extraQueryString}` : `?${extraQueryString}`;
        }
        $('.plpBreadCrumbsCta').attr('href', href + queryString);
    }
}
function updateBasketLinksForHiddenDeals() {
    document.querySelectorAll('.basket-item-image-url').forEach(function (el) {
        el.addEventListener('click', function (e) {
            let hiddenCookie = getCookie('hiddenAffiliateId');
            if (!hiddenCookie) {
                e.preventDefault();
                let basePath = el.getAttribute('href').split('?')[0];
                let tariff = el.getAttribute('data-tariff');
                let gift = el.getAttribute('data-gift');
                let product = el.getAttribute('data-product');
                if (tariff && gift && product) {
                    let newUrl = `${basePath}?tariffcode=${tariff}&giftcode=${gift}&productcode=${product}`;
                    window.open(newUrl, '_blank'); // because you use target="_blank"
                } else {
                    window.open(basePath, '_blank');
                }
            }
        });
    });
}
function setEqualHeight() {
    if ($('.handsetPromoGiftBoxDesktop').length) {
        $('.handsetPromoGiftBoxDesktop').css('min-height', 'auto');
        if (window.innerWidth > 1023) {
            let lastRefId = 0;
            $('.handsetPromoGiftBoxDesktop').each(function() {
                let refId = $(this).attr('data-ref');
                if (lastRefId != refId) {
                    lastRefId = refId;
                    let countPromoSlot = ($('.promoSlot' + refId).length) ? document.querySelectorAll('.promoSlot' + refId).length : 0;
                    let countTagSlot = ($('.tagSlot' + refId).length) ? document.querySelectorAll('.tagSlot' + refId).length : 0;
                    if (countPromoSlot == 2 && countTagSlot == 2) {
                        let height = $('.tagSlot1' + refId)[0].getBoundingClientRect().height;
                        let heightD = $('.promoSlot1' + refId)[0].getBoundingClientRect().height;
                        if (height > heightD) {
                            $('.promoSlot1' + refId)[0].style.setProperty('min-height', `${parseFloat(height)}px`, 'important');
                        }
                        if (heightD > height) {
                            $('.tagSlot1' + refId)[0].style.setProperty('min-height', `${parseFloat(heightD)}px`, 'important');
                        }
                        height = $('.tagSlot2' + refId)[0].getBoundingClientRect().height;
                        heightD = $('.promoSlot2' + refId)[0].getBoundingClientRect().height;
                        if (height > heightD) {
                            $('.promoSlot2' + refId)[0].style.setProperty('min-height', `${parseFloat(height)}px`, 'important');
                        }
                        if (heightD > height) {
                            $('.tagSlot2' + refId)[0].style.setProperty('min-height', `${parseFloat(heightD)}px`, 'important');
                        }
                    }
                    if (countPromoSlot == 2 && countTagSlot == 1) {
                        let height = $('.tagSlot1' + refId)[0].getBoundingClientRect().height;
                        let heightD = $('.promoSlot2' + refId)[0].getBoundingClientRect().height;
                        if (height > heightD) {
                            $('.promoSlot2' + refId)[0].style.setProperty('min-height', `${parseFloat(height)}px`, 'important');
                        }
                        if (heightD > height) {
                            $('.tagSlot1' + refId)[0].style.setProperty('min-height', `${parseFloat(heightD)}px`, 'important');
                        }
                    }
                    if (countPromoSlot == 1 && countTagSlot == 2) {
                        let height = $('.tagSlot2' + refId)[0].getBoundingClientRect().height;
                        let heightD = $('.promoSlot1' + refId)[0].getBoundingClientRect().height;
                        if (height > heightD) {
                            $('.promoSlot1' + refId)[0].style.setProperty('min-height', `${parseFloat(height)}px`, 'important');
                        }
                        if (heightD > height) {
                            $('.tagSlot2' + refId)[0].style.setProperty('min-height', `${parseFloat(heightD)}px`, 'important');
                        }
                    }
                    if (countPromoSlot == 1 && countTagSlot == 1) {
                        let height = $('.tagSlot1' + refId)[0].getBoundingClientRect().height;
                        let heightD = $('.promoSlot1' + refId)[0].getBoundingClientRect().height;
                        if (height > heightD) {
                            $('.promoSlot1' + refId)[0].style.setProperty('min-height', `${parseFloat(height)}px`, 'important');
                        }
                        if (heightD > height) {
                            $('.tagSlot1' + refId)[0].style.setProperty('min-height', `${parseFloat(heightD)}px`, 'important');
                        }
                    }
                    if (countPromoSlot == 2 && countTagSlot == 0) {
                        let height = $('.promoSlot2' + refId)[0].getBoundingClientRect().height;
                        let heightD = $('.promoSlot1' + refId)[0].getBoundingClientRect().height;
                        if (height > heightD) {
                            $('.promoSlot1' + refId)[0].style.setProperty('min-height', `${parseFloat(height)}px`, 'important');
                        }
                        if (heightD > height) {
                            $('.promoSlot2' + refId)[0].style.setProperty('min-height', `${parseFloat(heightD)}px`, 'important');
                        }
                    }
                    if (countPromoSlot == 0 && countTagSlot == 2) {
                        let height = $('.tagSlot1' + refId)[0].getBoundingClientRect().height;
                        let heightD = $('.tagSlot2' + refId)[0].getBoundingClientRect().height;
                        if (height > heightD) {
                            $('.tagSlot2' + refId)[0].style.setProperty('min-height', `${parseFloat(height)}px`, 'important');
                        }
                        if (heightD > height) {
                            $('.tagSlot1' + refId)[0].style.setProperty('min-height', `${parseFloat(heightD)}px`, 'important');
                        }
                    }
                }
            });
        }
    }
    debounceExtras();
}
function validateInsuranceInExtras() {
    let isChosen = false;
    const selectors = {
        component: '[data-insurance-component]',
        insuranceItem: '[data-insurance-item]',
        radio: 'input[type="radio"][name^="insurance-choice"]',
    };
    
    // Check all insurance radio buttons directly
    const allRadios = document.querySelectorAll(selectors.radio);
    allRadios.forEach((input) => {
        if (input.checked) {
            isChosen = true;
        }
    });
    
    return isChosen;
}
function toggleExtrasFooterCTA() {
    const $mainCTA = $('.extraUpsellAction');
    const $footerCTA = $('.footer-extras-cta');
    const fullyOut = isElementFullyOutOfView($mainCTA);
    if (fullyOut) {
        $footerCTA.addClass('visible');
    } else {
        $footerCTA.removeClass('visible');
    }
    if ($('.buttonGTB').length) {
        $('.footer-extras-cta .buttonGTB').attr('style', 'width: ' + $('.extraUpsellAction .buttonGTB').outerWidth(true) + 'px !important;');
    }
}
function isElementFullyOutOfView($el) {
    const rect = $el[0].getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return (
        rect.bottom < 0 || rect.top > windowHeight
    );
}
$(document).ready(function() {
    setEqualHeight();
    $('#colourUl li.active a').attr('aria-current', 'true');
    $('#capacityUl li.activeCapacityHandset a').attr('aria-current', 'true');
    $('.payment-toggle-handset .tabindexFocusEl.paymentChecked').attr('aria-current', 'true');
    $('.gallery-thumbnails-list .active[role="button"][tabindex="0"]').attr('aria-current', 'true');
    $(document).on('shown.bs.modal', '[data-video-modal]', function() {
        $('[data-video-modal] video')[0].play();
    });
    $(document).on('hide.bs.modal', '[data-video-modal]', function() {
        $('[data-video-modal] video')[0].pause();
    });
    if ($('.extraUpsellActionBtn').length) {
        $(document).on('click', '.extraUpsellActionBtn', function(e) {
            if (!validateInsuranceInExtras()) {
                e.preventDefault();
                $('#noInsuranceSelected').modal('toggle');
                let dataLayer = window.dataLayer || [];
                dataLayer.push({
                    'event': 'view',
                    'view_name': 'mobile insurance not selected',
                    'view_type': 'popup'
                });
            } else if ($('#extrasAccessoriesUrl').length) {
                $(this).attr('href', $('#extrasAccessoriesUrl').val());
                window.location.href = $('#extrasAccessoriesUrl').val();
            }
        });
    }
    $(document).on('click', '.extraUpsellActionBtnModalClose', function() {
        $('html, body').animate({
            scrollTop: $('.insurancePrices').offset().top - 50
        }, 'slow');
    });
    function lockBody() {
        const y = window.scrollY;
        document.body.dataset.lockedScrollY = y;
        document.body.classList.add('body-scroll-locked');
        Object.assign(document.body.style, {
            position: 'fixed',
            top: `-${y}px`,
            left: '0',
            right: '0',
            width: '100%',
            overflow: 'hidden'
        });
    }
    function unlockBody() {
        if (!document.body.classList.contains('body-scroll-locked')) return;
        const y = parseInt(document.body.dataset.lockedScrollY || '0', 10);
        const s = document.body.style;
        s.position = s.top = s.left = s.right = s.width = s.overflow = '';
        document.body.classList.remove('body-scroll-locked');
        delete document.body.dataset.lockedScrollY;
        window.scrollTo({ top: y, behavior: 'instant' });
    }
    $(document).on('click', '.promoModalToggle, .promoPDPModalToggle', function() {
        $('#' + $(this).attr('data-target')).modal('show');
        document.body.classList.add('noScrollToTop');
        if (window.innerWidth < 720) {
            lockBody();
        }
    });
    $(document).on('click', '.promoModalToggleClose, .modal-backdrop', function() {
        document.body.classList.remove('noScrollToTop');
        if (window.innerWidth < 720) {
            unlockBody();
        }
    });
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            document.body.classList.remove('noScrollToTop');
            if (window.innerWidth < 720) {
                unlockBody();
            }
        }
    });
    $(window).resize(function() {
        unlockBody();
    });
});
document.addEventListener('DOMContentLoaded', function () {
    updateBasketLinksForHiddenDeals();
});
// Specific class for OS
document.addEventListener('DOMContentLoaded', () => {
    const platform = navigator.platform;
    if (platform.includes('Mac')) {
        document.body.classList.add('mac');
    } else if (platform.includes('Win')) {
        document.body.classList.add('windows');
    }
});
